import plural from 'helpers/plural';

angular.module('filters').filter('membershipAccessMessageFilter', ["$filter", function($filter) {
  return function(plan) {
    var classString, intervalNumberString, intervalString, intervalUnitString, termString, termUnit;
    classString = plural('classes', plan.classes_limit, true);
    intervalUnitString = plural(plan.classes_interval_unit, plan.classes_interval_number);
    intervalNumberString = plan.classes_interval_number > 1 ? plan.classes_interval_number : '';
    intervalString = plan.classes_unlimited || !plan.classes_interval_number || !plan.classes_interval_unit ? '' : `every ${intervalNumberString} ${intervalUnitString}`;
    termString = plan.term_number ? (termUnit = plural(plan.term_unit, plan.term_number), `- you'll have ${plan.term_number} ${termUnit} to use them!`) : "for the life of the membership!";
    switch (false) {
      case !plan.classes_unlimited:
        return `Access to unlimited classes ${termString}`;
      case !plan.classes_limit:
        return `Access to ${classString} ${intervalString} ${termString}`;
      default:
        return '';
    }
  };
}]);
